export const Footer = (): JSX.Element => {
  return (
    <footer className="flex flex-col justify-center items-center bg-bg-white p-5 sm:p-8">
      <img className="w-24 sm:w-36" src="/logo.png" alt="logo" />
      <p className="text-gray text-xs sm:text-sm pt-3 sm:pt-6">
        대표: 김장민 | 주소: 경기도 하남시 초이로 99번길 49-32
      </p>
      <p className="text-gray text-xs sm:text-sm pt-2">
        사업자등록번호: 740-71-00525
      </p>
    </footer>
  );
};
